import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import messages from './translations/main'
import router from './router'
import store from '@/store'
import STGallery from '@scantrust/st-gallery'

import { default as axios }  from './utils/axios.instances' // eslint-disable-line
const axiosInstance = axios.getSTAxios() // eslint-disable-line

Vue.use(VueI18n)
Vue.use(Vuelidate)
Vue.use(STGallery)

Vue.prototype.$axios = axiosInstance
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: 'en',
  ...messages
})

Vue.prototype.$trnslt = i18n

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
